<template>
  <div>
    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
      @onChange="onSearchItemChange"
    ></SearchField>

    <Table
      ref="table"
      :tableHeight="tableHeight"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :btns="btns"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "hazardweekly",
      formInline: {},
      formCtrl: [
        {
          label: "检查人：",
          keyName: "checker",
          placeholder: "请填写检查人",
          type: "text",
        },
        {
          label: "检查时间：",
          keyName: "check_date",
          placeholder: "请选择检查时间",
          type: "daterange",
        },
      ],
      cols: [
        { prop: "title", label: "标题", minwidth: 200 },
        { prop: "checker", label: "检查人", minwidth: 120 },
        { prop: "check_date", label: "检查时间", minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "预览",
          cb: ({ id }) => {
            this.$router.push(`/vehicle/pdf?id=${id}`);
          },
        },
        {
          title: "下载",
          img: require("@/assets/img/icon_xz.png"),
          unimg: require("@/assets/img/icon_xz_hover.png"),
          cb: ({ id }) => {
            const a = document.createElement("a");
            a.href = this.IP + "/fleet/hazardweekly/pdf?mode=download&id=" + id;
            // a.download = name;
            a.click();
          },
        },
      ],
    };
  },
  methods: {
    dataObjHandler(v) {
      const o = {
        title: "车辆日常检查记录表",
      };
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          o[key] = v[key];
        }
      }
      return o;
    },
  },
  mounted() {},
};
</script>
